"use client"
import FiltersWrapper from "@/ui/FiltersWrapper/FiltersWrapper"
import { extractProperty, getNonUmbracoUrl } from "@/utils"
import React from "react"
import BulletsCardsList from "ui/BulletsCardsList/BulletsCardsList"
import BulletsCardsListMobileSwiper from "ui/BulletsCardsList/BulletsCardsListMobileSwiper"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import CommonTitle from "ui/common/bit/CommonTitle"
import { sendBlockEvent } from "utils/gtm"
import { extractBlockProperties, transformProperties } from "utils/simplifyData"
import { Mobile } from "../../common/bit/MediaQueries"
import { StyledBlockWrapper, StyledMiddleCommonTitle } from "./styles"

interface MultiTypeCardsProps {
  data: any
  id?: string
}

const MultiTypeCards: React.FC<MultiTypeCardsProps> = ({ id, data }) => {
  const {
    title,
    subtitle,
    mobileTitle,
    mobileSubtitle,
    itemsListPriority,
    itemsListComplete,
    button,
  } = data
  const itemsListPriorityCategories = new Set(
    itemsListPriority?.blocks?.map((item: any) =>
      extractProperty(item, "filter"),
    ),
  )

  // Helper to get category name for a card
  const getCategoryName = (item: any) => {
    // Try to extract category/filter from the item or fallback to block title
    return extractProperty(item, "filter") || title.value
  }

  // Handler for GTM event firing
  const handleCardButtonClick = (item: any, categoryName?: string) => {
    const props = transformProperties(item.properties)
    const productTitle = props.title?.value || ""
    const category = categoryName || getCategoryName(item)
    sendBlockEvent({
      blockId: id || "",
      title: title?.value,
      componentName: "מוצרים",
      productName: `${category} - ${productTitle}`,
      actionName: undefined,
      buttonName: props.button?.links?.[0]?.name || undefined,
    })
  }

  const parsedItemsListPriority = extractBlockProperties(
    itemsListPriority?.blocks,
  )
  return (
    <StyledBlockWrapper id={id} style={{ alignItems: "center" }}>
      <CommonTitle subtitle={subtitle.value}>{title.value}</CommonTitle>
      {itemsListPriority && (
        <FiltersWrapper
          categories={Array.from(itemsListPriorityCategories) as string[]}
          itemsList={parsedItemsListPriority}
        >
          <BulletsCardsList
            itemsList={parsedItemsListPriority}
            onButtonClick={handleCardButtonClick}
            categoryName={title.value}
          />
        </FiltersWrapper>
      )}
      <Mobile>
        <StyledMiddleCommonTitle
          mobileTitle={mobileTitle.value}
          mobileSubtitle={mobileSubtitle.value}
        />
      </Mobile>
      {itemsListComplete?.blocks?.length > 0 && (
        <BulletsCardsListMobileSwiper
          itemList={itemsListComplete.blocks}
          onButtonClick={handleCardButtonClick}
          categoryName={title.value}
        />
      )}
      {button && (
        <ButtonWithArrow
          colorPallette={"blue"}
          href={getNonUmbracoUrl(button?.links[0]?.url)}
          variant="elevated"
          onClick={() =>
            sendBlockEvent({
              blockId: id || "",
              title: title?.value,
              componentName: "מוצרים",
              productName: title?.value,
              actionName: undefined,
              buttonName: button.links[0]?.name || undefined,
            })
          }
        >
          {button.links[0]?.name}
        </ButtonWithArrow>
      )}
    </StyledBlockWrapper>
  )
}

export default MultiTypeCards
